import { render } from "./AsideFilter.vue?vue&type=template&id=240cdb7b"
import script from "./AsideFilter.vue?vue&type=script&lang=js"
export * from "./AsideFilter.vue?vue&type=script&lang=js"

import "./AsideFilter.vue?vue&type=style&index=0&id=240cdb7b&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__